/*
  Выбор получателя и способа передачи ссылки в кабинет должника - §3.8.2.

  Вынесено из `DebtorLink` 21.10.2026: файл с серверными страницами списка ссылок упёрся в
  предел размера компонента. Здесь только показ полей и кнопки; что делать при нажатии
  (спросить подтверждение замены, выдать, показать адрес), решает `DebtorLink`.
*/

import { LINK_PURPOSE_TITLES, PERSON_ROLE_TITLES } from '../api/format.js'
import Dropdown from './Select.jsx'

export default function DebtorLinkChoice({ recipients, choice, onChoice, onIssue, busy }) {
  // Телефон в строку списка не идёт: с фамилией и ролью она не помещается в
  // поле и обрывается многоточием - как раз на номере. Он показан ниже, у
  // выбранного получателя, где и нужен: ссылку сейчас отправляет человек.
  const people = Object.fromEntries(
    recipients.map((person) => [
      person.person_id,
      `${person.name}, ${PERSON_ROLE_TITLES[person.role]}`,
    ]),
  )
  const chosen = recipients.find((person) => person.person_id === choice.person)

  return (
    <>
      {/*
        Два поля и кнопка в одну строку не помещаются в колонку карточки:
        в фамилию с ролью и телефоном нужна вся ширина. Поэтому получатель
        стоит своей строкой, а кнопка - в строке со способом передачи, на
        одной линии с ним (правило 6г скилла кабинета).
      */}
      <div className="row">
        <div className="field field--l">
          <span className="field__label" id="link-person-label">
            Кому выдать
          </span>
          <Dropdown
            value={choice.person}
            onChange={(person) => onChoice({ ...choice, person })}
            options={people}
            empty="на счёт целиком"
            labelledBy="link-person-label"
          />
        </div>
      </div>
      {chosen ? (
        <div className="muted">
          {chosen.phone
            ? `Телефон получателя: ${chosen.phone}`
            : 'Телефон получателя неизвестен - передайте адрес другим способом.'}
        </div>
      ) : null}
      <div className="row">
        <div className="field field--s">
          <span className="field__label" id="link-purpose-label">
            Как передадите
          </span>
          <Dropdown
            value={choice.purpose}
            onChange={(purpose) => onChoice({ ...choice, purpose })}
            options={LINK_PURPOSE_TITLES}
            labelledBy="link-purpose-label"
          />
        </div>
        <button className="button" type="button" onClick={onIssue} disabled={busy}>
          Выдать ссылку
        </button>
      </div>
      <div className="muted">
        От способа передачи зависит срок жизни ссылки: продиктованную по телефону человек открывает
        не сразу, и она живёт дольше.
      </div>
    </>
  )
}
